<template>
  <div class="add-client-contact-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Examinee Contact Details</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <form autocomplete="off">
            <div class="modal-body div-responsive">
              <div class="box-body">
                <div class="box-row">
                  <div class="box-col box-col-left">Mobile</div>
                  <div class="box-col box-col-right">
                    <input type="tel" class="textbox w-100 mobile" maxlength="20" v-model="contacts.mobile" placeholder="+61 followed by 9 digits (12 characters)"
                           @blur="normalizePhoneField('mobile')" />
                    <div class="text-danger" v-if="hasError && mobileError">{{ mobileError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-center box-col-left">Email Address</div>
                  <div class="box-col box-col-right">
                    <input autocomplete="off" class="textbox w-100" type="text" maxlength="100" v-model="contacts.email" placeholder="Email Address"
                           @blur="trimEmail" />
                    <div class="text-danger" v-if="hasError && emailError">{{ emailError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-center box-col-left">Land line</div>
                  <div class="box-col box-col-right">
                    <input class="textbox w-100" type="tel" v-model="contacts.landline" placeholder="Land line (optional, 12 characters if set)"
                           @blur="normalizePhoneField('landline')" />
                    <div class="text-danger" v-if="hasError && landLineError">{{ landLineError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-center box-col-left">Work Number</div>
                  <div class="box-col box-col-right">
                    <input class="textbox w-100" type="tel" v-model="contacts.workNumber" placeholder="Work number (optional, 12 characters if set)"
                           @blur="normalizePhoneField('workNumber')" />
                    <div class="text-danger" v-if="hasError && workNumberError">{{ workNumberError }}</div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="clickSave" dark>Save</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'

  export default {
    name: 'AddClientContactModal',
    props: ['typrProps'],
    data() {
      return {
        loadModal: false,
        hasError: false,
        singleCase: utilities.initCase(),
        contacts: utilities.initContactDetails(),
        booking: utilities.initBooking(),
        // loaded: false,
      }
    },

    computed: {
      /** Optional fields: validate format only when the user entered a value. */
      mobileError() {
        const n = utilities.normalizeAuPhoneInput(this.contacts.mobile)
        if (!n) return ''
        return utilities.getClientContactPhoneAu12Error(n, 'Mobile')
      },
      emailError() {
        return utilities.getClientContactEmailError(this.contacts.email, 'Email address', false)
      },
      landLineError() {
        const n = utilities.normalizeAuPhoneInput(this.contacts.landline)
        if (!n) return ''
        if (!utilities.validateLandPhone(n)) {
          return 'Enter a valid land line (6-digit 13…, or use + and digits as required).'
        }
        return ''
      },
      workNumberError() {
        const n = utilities.normalizeAuPhoneInput(this.contacts.workNumber)
        if (!n) return ''
        if (!utilities.validateLandPhone(n)) {
          return 'Enter a valid work number (6-digit 13…, or use + and digits as required).'
        }
        return ''
      },
    },

    methods: {
      trimEmail() {
        if (this.contacts.email === undefined || this.contacts.email === null) return
        this.contacts.email = String(this.contacts.email).trim()
      },
      normalizePhoneField(field) {
        const raw = this.contacts[field]
        if (raw === undefined || raw === null || String(raw).trim() === '') {
          this.contacts[field] = ''
          return
        }
        this.contacts[field] = utilities.normalizeAuPhoneInput(raw)
      },
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          this.hasError = false
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },

      async clickSave() {
        this.trimEmail()
        this.normalizePhoneField('mobile')
        this.normalizePhoneField('landline')
        this.normalizePhoneField('workNumber')
        this.hasError = false
        if (this.mobileError || this.emailError || this.landLineError || this.workNumberError) {
          this.hasError = true
          return
        }
        if (this.typrProps == 'fromcases') {
          this.saveToCaseContact()
        } else if (this.typrProps == 'fromBooking') {
          this.saveToBookingContact()
        } else if (this.typrProps == 'consentForm') {
          this.setToConsentFrom()
        }
        this.handleModal()
      },

      setToConsentFrom() {
        this.$parent.singleCase.claimantPhone1 = utilities.validatePhonenumber(this.contacts.landline)
        this.$parent.singleCase.claimantPhone2 = utilities.validatePhonenumber(this.contacts.workNumber)
        this.$parent.singleCase.claimantMobile = this.contacts.mobile
        this.$parent.singleCase.claimantEmail = this.contacts.email
        this.$parent.isEditContact = true
        if (this.contacts.landline == '' && this.contacts.workNumber == '' && this.contacts.mobile == '' && this.contacts.email == '') {
          this.$parent.isEditContact = false
        }

        this.$parent.contactKey += 1
        this.$forceUpdate()
        this.$emit('updateContact', this.contacts)
        this.$parent.tapUpdate()
      },

      setCaseContactDetails() {
        this.singleCase = this.$parent.singleCase
        this.contacts.landline = this.singleCase.ClaimantPhone1
        this.contacts.mobile = this.singleCase.ClaimantMobile
        this.contacts.workNumber = this.singleCase.ClaimantPhone2
        this.contacts.email = this.singleCase.ClaimantEmail
      },

      setCaseContactDetailsLowerCase() {
        this.singleCase = this.$parent.singleCase
        this.contacts.landline = this.singleCase.claimantPhone1
        this.contacts.mobile = this.singleCase.claimantMobile
        this.contacts.workNumber = this.singleCase.claimantPhone2
        this.contacts.email = this.singleCase.claimantEmail
      },

      setBookingContactDetails() {
        this.contacts.landline = this.booking.claimantPhone1
        this.contacts.mobile = this.booking.claimantMobile
        this.contacts.workNumber = this.booking.claimantPhone2
        this.contacts.email = this.booking.claimantEmail
      },

      saveToCaseContact() {

        if (this.$parent.singleCase.id != '') {

          this.$parent.singleCase.ClaimantPhone1 = utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contacts.landline))
          this.$parent.singleCase.ClaimantPhone2 = utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contacts.workNumber))
          this.$parent.singleCase.ClaimantMobile = utilities.normalizeAuPhoneInput(this.contacts.mobile)
          this.$parent.singleCase.ClaimantEmail = this.contacts.email
          this.$parent.isEditContact = true
          if (this.contacts.landline == '' && this.contacts.workNumber == '' && this.contacts.mobile == '' && this.contacts.email == '') {
            this.$parent.isEditContact = false
          }
          this.$parent.contactKey += 1
          // If cancel, don't save
        } else {
          this.$parent.singleCase.ClaimantPhone1 = utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contacts.landline))
          this.$parent.singleCase.ClaimantPhone2 = utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contacts.workNumber))
          this.$parent.singleCase.ClaimantMobile = utilities.normalizeAuPhoneInput(this.contacts.mobile)
          this.$parent.singleCase.ClaimantEmail = this.contacts.email
          this.$parent.isEditContact = true
          if (this.contacts.landline == '' && this.contacts.workNumber == '' && this.contacts.mobile == '' && this.contacts.email == '') {
            this.$parent.isEditContact = false
          }
          this.$parent.contactKey += 1
        }
      },

      saveToBookingContact() {
        this.booking.claimantPhone1 = utilities.validatePhonenumber(this.contacts.landline)
        this.booking.claimantPhone2 = utilities.validatePhonenumber(this.contacts.workNumber)
        this.booking.claimantMobile = this.contacts.mobile
        this.booking.claimantEmail = this.contacts.email
        this.$parent.booking = this.booking
        this.$parent.isEditContact = true
        if (this.contacts.landline == '' && this.contacts.workNumber == '' && this.contacts.mobile == '' && this.contacts.email == '') {
          this.$parent.isEditContact = false
        }
        this.$parent.contactKey += 1
      },
    },

    beforeMount() {
      // if(this.$parent.booking != undefined) this.booking = this.$parent.booking
    },
    mounted() {},
    updated() {
      // if (!this.loaded) {
      //   this.contacts.landline = this.booking.claimantPhone1
      //   this.contacts.mobile = this.booking.claimantMobile
      //   this.contacts.workNumber = this.booking.claimantPhone2
      //   this.contacts.email = this.booking.claimantEmail
      //   this.loaded = true
      // }
    },
  }
</script>
